import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";

const Items = ({ items, maxHeight = '75vh', handleClick }) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                padding: 2,
            }}
        >
            {/* Scrollable Container */}
            <Box
                sx={{
                    width: '100%',
                    // maxWidth: 1400,
                    maxHeight: maxHeight,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    paddingRight: 1,
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,0.2)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    },
                }}
            >
                <Grid container spacing={3}>
                    {items.map((item, index) => (
                        <Grid item xs={12} sm={4} key={item.sku}>
                            <Card

                                sx={{
                                    height: '100%',
                                    transition: 'all 0.2s ease-in-out',
                                    '&:hover': {
                                        boxShadow: 6,
                                        transform: 'translateY(-4px)',
                                    },
                                }}
                            >
                                <CardActionArea
                                    // onClick={() => navigate(`/SelectAProduct/${customer?.customerid}/${customer?.StoreName}`)}
                                    onClick={() => handleClick(item)}
                                    sx={{
                                        height: '100%',
                                        '&[data-active]': {
                                            backgroundColor: 'action.selected',
                                            '&:hover': {
                                                backgroundColor: 'action.selectedHover',
                                            },
                                        },
                                    }}
                                >
                                    <CardContent sx={{ height: '100%', p: 3 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography
                                                    variant="h6"
                                                    component="div"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    {item?.size}
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    component="div"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    {item?.sku}
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    component="div"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    {item?.material}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={6} sx={{ textAlign: "right" }}>
                                                <Typography
                                                    variant="h6"
                                                    component="div"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    {(item?.qty > 0) && `x${item?.qty}`}
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    component="div"
                                                    fontWeight="bold"
                                                    gutterBottom
                                                >
                                                    ${item?.price}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}

export default Items